import React from 'react'

import { Container } from './style'

const Main = ({ children }) => {
  return <Container>{children}</Container>
}

export default Main
